import { useEffect } from 'react';

import { useStationsOperations } from './useStationsOperations';
import { useShowFavouriteStations } from './useShowFavouriteStations';

export const useInitFavouriteStations = () => {
  const { getFavouriteStations } = useStationsOperations();
  const showFavouriteStations = useShowFavouriteStations();

  useEffect(() => {
    if (showFavouriteStations) {
      getFavouriteStations();
    }
  // eslint-disable-next-line
  }, [showFavouriteStations]);
};
